import React ,{useState} from 'react'
import Storeitems from '../data/Storeitems.json'
import ManPart from './ManPart';
import RandomPart from './RandomPart';
import WomanPart from './WomanPart';

export default function StoreMain() {
    const [viwe,setViwe]=useState(<div className=' divide-y-2 divide-yakam'>

            <div className="mx-auto container flex justify-center items-center py-12 px-4 sm:px-6 2xl:px-0">
                <div className="flex flex-col lg:flex-row justify-center items-center space-y-6 lg:space-y-0">
                    <div className="w-80 sm:w-auto flex flex-col justify-start items-start">
                        <div>
                            <p className="text-3xl xl:text-4xl font-semibold leading-9 text-shasham">کاڵای وەرزشی پیاوان</p>
                        </div>
                        <div className="mt-4 lg:w-4/5 xl:w-3/5">
                            <p className="text-md leading-6 md:w-[700px] text-shasham">باشترین کاڵا وەرزشیەکان لێرە بەدەست بێنە</p>
                        </div>
                        <div className="mt-16 w-full">
                            <button onClick={()=>{return setViwe(<ManPart/>)}} className="px-4 bg-seyam flex justify-between items-center w-full lg:w-72 h-14 text-white hover:bg-shasham">
                                <p className="text-xl text-yakam font-medium leading-5">زیاتر ببینە</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.66663 16H25.3333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20 21.3333L25.3333 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20 10.6667L25.3333 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div className="flex flex-row sm:flex-row jusitfy-center items-center sm:space-x-5 xl:space-x-8 space-y-4 sm:space-y-0">
                        <div>
                            <img className="hidden lg:block object-contain w-44 h-44" src={Storeitems[0].man.kit[0].Pimg} alt="sofa" />
                            <img className="w-52 sm:w-auto lg:hidden h-52" src={Storeitems[0].man.kit[0].Pimg} alt="sofa" />
                        </div>
                        <div className="flex flex-col justify-center items-center space-y-4 sm:space-y-5 lg:space-y-5 xl:space-y-8">
                            <div>
                                <img className="hidden lg:block w-44 h-44" src={Storeitems[0].man.shoes[6].Pimg} alt="chairs" />
                                <img className="w-52 h-52 sm:w-auto lg:hidden" src={Storeitems[0].man.shoes[6].Pimg} alt="chairs" />
                            </div>
                            <div>
                                <img className="hidden lg:block w-44 h-44" src={Storeitems[0].man.tracksuit[6].Pimg} alt="chairs" />
                                <img className="w-52 h-52 sm:w-auto lg:hidden" src={Storeitems[0].man.tracksuit[6].Pimg} alt="chairs" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="mx-auto container flex justify-center items-center py-12 px-4 sm:px-6 2xl:px-0">
                <div className="flex flex-col lg:flex-row justify-center items-center space-y-6 lg:space-y-0">
                    <div className="w-80 sm:w-auto flex flex-col justify-start items-start">
                        <div>
                            <p className="text-3xl xl:text-4xl font-semibold leading-9 text-shasham">کاڵای وەرزشی ئافرەتان</p>
                        </div>
                        <div className="mt-4 lg:w-4/5 xl:w-3/5">
                            <p className="text-md leading-6 md:w-[700px] text-shasham">باشترین کاڵا وەرزشیەکان لێرە بەدەست بێنە</p>
                        </div>
                        <div className="mt-16 w-full">
                            <button onClick={()=>{return setViwe(<WomanPart/>)}} className="px-4 bg-seyam flex justify-between items-center w-full lg:w-72 h-14 text-white hover:bg-shasham">
                                <p className="text-xl text-yakam font-medium leading-5">زیاتر ببینە</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.66663 16H25.3333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20 21.3333L25.3333 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20 10.6667L25.3333 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div className="flex flex-row sm:flex-row jusitfy-center items-center sm:space-x-5 xl:space-x-8 space-y-4 sm:space-y-0">
                        <div>
                            <img className="hidden lg:block object-contain w-44 h-44" src={Storeitems[0].woman.kit[3].Pimg} alt="sofa" />
                            <img className="w-52 sm:w-auto lg:hidden h-52" src={Storeitems[0].woman.kit[3].Pimg} alt="sofa" />
                        </div>
                        <div className="flex flex-col justify-center items-center space-y-4 sm:space-y-5 lg:space-y-5 xl:space-y-8">
                            <div>
                                <img className="hidden lg:block w-44 h-44" src={Storeitems[0].woman.shoes[6].Pimg} alt="chairs" />
                                <img className="w-52 h-52 sm:w-auto lg:hidden" src={Storeitems[0].woman.shoes[6].Pimg} alt="chairs" />
                            </div>
                            <div>
                                <img className="hidden lg:block w-44 h-44" src={Storeitems[0].woman.tracksuit[2].Pimg} alt="chairs" />
                                <img className="w-52 h-52 sm:w-auto lg:hidden" src={Storeitems[0].woman.tracksuit[2].Pimg} alt="chairs" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="mx-auto container flex justify-center items-center py-12 px-4 sm:px-6 2xl:px-0">
                <div className="flex flex-col lg:flex-row justify-center items-center space-y-6 lg:space-y-0">
                    <div className="w-80 sm:w-auto flex flex-col justify-start items-start">
                        <div>
                            <p className="text-3xl xl:text-4xl font-semibold leading-9 text-shasham">کاڵای وەرزشی هەمەجۆر</p>
                        </div>
                        <div className="mt-4 lg:w-4/5 xl:w-3/5">
                            <p className="text-md leading-6 md:w-[700px] text-shasham">باشترین کاڵا وەرزشیەکان لێرە بەدەست بێنە</p>
                        </div>
                        <div className="mt-16 w-full">
                            <button onClick={()=>{return setViwe(<RandomPart/>)}} className="px-4 bg-seyam flex justify-between items-center w-full lg:w-72 h-14 text-white hover:bg-shasham">
                                <p className="text-xl text-yakam font-medium leading-5">زیاتر ببینە</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.66663 16H25.3333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20 21.3333L25.3333 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20 10.6667L25.3333 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div className="flex flex-row sm:flex-row jusitfy-center items-center sm:space-x-5 xl:space-x-8 space-y-4 sm:space-y-0">
                        <div>
                            <img className="hidden lg:block object-contain w-44 h-44" src={Storeitems[0].random.ball[3].Pimg} alt="sofa" />
                            <img className="w-62 sm:w-auto lg:hidden h-44" src={Storeitems[0].random.ball[3].Pimg} alt="sofa" />
                        </div>
                        <div className="flex flex-col justify-center items-center space-y-4 sm:space-y-5 lg:space-y-5 xl:space-y-8">
                            <div>
                                <img className="hidden lg:block w-44 h-44" src={Storeitems[0].random.water[6].Pimg} alt="chairs" />
                                <img className="w-52 h-52 sm:w-auto lg:hidden" src={Storeitems[0].random.water[6].Pimg} alt="chairs" />
                            </div>
                            <div>
                                <img className="hidden lg:block w-44 h-44" src={Storeitems[0].random.swim[2].Pimg} alt="chairs" />
                                <img className="w-40 h-40 sm:w-auto lg:hidden" src={Storeitems[0].random.swim[2].Pimg} alt="chairs" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>)

    return (
        <>

            {viwe}
        </>
    )
}
